import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faMapMarkerAlt, 
  faTools,
  faClock,
  faArrowUp,
  faAppleAlt
} from '@fortawesome/free-solid-svg-icons';
import { 
  faWhatsapp, 
  faInstagram, 
  faTiktok 
} from '@fortawesome/free-brands-svg-icons';
import './footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const quickLinks = [
    { id: 1, title: 'Beranda', link: '#', section: 'header' },
    { id: 2, title: 'Tentang Kami', link: '#about', section: 'about' },
    { id: 3, title: 'Layanan', link: '#services', section: 'services' },
    { id: 4, title: 'Lokasi', link: '#portfolio', section: 'portfolio' },
    { id: 5, title: 'Testimoni', link: '#testimonials', section: 'testimonials' },
    { id: 6, title: 'FAQ', link: '#faqs', section: 'faqs' },
    { id: 7, title: 'Kontak', link: '#contact', section: 'contact' }
  ];

  const services = [
    { id: 1, title: 'Ganti Layar', icon: faAppleAlt },
    { id: 2, title: 'Ganti Baterai', icon: faTools },
    { id: 3, title: 'Reparasi Software', icon: faTools },
    { id: 4, title: 'Reparasi Hardware', icon: faTools },
    { id: 5, title: 'Pemulihan Data', icon: faTools },
    { id: 6, title: 'Konsultasi Gratis', icon: faTools }
  ];

  const socialLinks = [
    { 
      id: 1, 
      platform: 'WhatsApp', 
      icon: faWhatsapp, 
      link: 'https://api.whatsapp.com/send?phone=62895339559888',
      color: '#25D366'
    },
    { 
      id: 2, 
      platform: 'Instagram', 
      icon: faInstagram, 
      link: 'https://www.instagram.com/itechservice.id/',
      color: '#E4405F'
    },
    { 
      id: 3, 
      platform: 'TikTok', 
      icon: faTiktok, 
      link: 'https://www.tiktok.com/@itechservice.id',
      color: '#000000'
    }
  ];

  const handleLinkClick = (link, section) => {
    if (section === 'header') {
      scrollToTop();
    } else {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer__content" data-aos="fade-up">
          {/* Company Info */}
          <div className="footer__section footer__company">
            <div className="footer__logo">
              <h3 className="footer__logo-text">iTech Service</h3>
              <span className="footer__logo-tagline">Reparasi Perangkat Apple Profesional</span>
            </div>
            
            <p className="footer__description">
            iTech Service hadir untuk membantu kebutuhan servis perangkat Apple dengan penanganan yang cepat, nyaman, dan berkualitas, didukung garansi layanan serta suku cadang pilihan.
            </p>

            <div className="footer__contact-info">
              <div className="footer__contact-item">
                <FontAwesomeIcon icon={faPhone} className="footer__contact-icon" />
                <a href="tel:+62895339559888" className="footer__contact-link">
                  +62 895-3395-59888
                </a>
              </div>
              
              <div className="footer__contact-item">
                <FontAwesomeIcon icon={faEnvelope} className="footer__contact-icon" />
                <a href="mailto:itechservice.id@gmail.com" className="footer__contact-link">
                  itechservice.id@gmail.com
                </a>
              </div>
              
              <div className="footer__contact-item">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="footer__contact-icon" />
                <span className="footer__contact-text">
                  Sidoarjo, Surabaya, Malang, Mojokerto
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer__section footer__links">
            <h4 className="footer__section-title">Navigasi Cepat</h4>
            <ul className="footer__links-list">
              {quickLinks.map(link => (
                <li key={link.id} className="footer__links-item">
                  <button 
                    onClick={() => handleLinkClick(link.link, link.section)}
                    className="footer__link"
                  >
                    {link.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="footer__section footer__services">
            <h4 className="footer__section-title">Layanan Kami</h4>
            <ul className="footer__services-list">
              {services.map(service => (
                <li key={service.id} className="footer__service-item">
                  <FontAwesomeIcon icon={service.icon} className="footer__service-icon" />
                  <span className="footer__service-text">{service.title}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Business Hours & Social */}
          <div className="footer__section footer__extras">
            <h4 className="footer__section-title">Jam Operasional</h4>
            <div className="footer__hours">
              <div className="footer__hours-item">
                <FontAwesomeIcon icon={faClock} className="footer__hours-icon" />
                <div className="footer__hours-details">
                  <span className="footer__hours-days">Senin - Rabu</span>
                  <span className="footer__hours-time">10:00 - 21:00</span>
                </div>
              </div>
              
              <div className="footer__hours-item">
                <FontAwesomeIcon icon={faClock} className="footer__hours-icon" />
                <div className="footer__hours-details">
                  <span className="footer__hours-days">Kamis</span>
                  <span className="footer__hours-time">Tutup</span>
                </div>
              </div>
              
              <div className="footer__hours-item">
                <FontAwesomeIcon icon={faClock} className="footer__hours-icon" />
                <div className="footer__hours-details">
                  <span className="footer__hours-days">Jumat - Minggu</span>
                  <span className="footer__hours-time">10:00 - 21:00</span>
                </div>
              </div>
            </div>

            <div className="footer__social">
              <h5 className="footer__social-title">Ikuti Kami</h5>
              <div className="footer__social-links">
                {socialLinks.map(social => (
                  <a
                    key={social.id}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social-link"
                    style={{'--social-color': social.color}}
                    aria-label={`Ikuti kami di ${social.platform}`}
                  >
                    <FontAwesomeIcon icon={social.icon} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer__bottom" data-aos="fade-up" data-aos-delay="200">
          <div className="footer__copyright">
            <p className="footer__copyright-text">
              © {new Date().getFullYear()} iTech Service. All rights reserved.
            </p>
            <p className="footer__legal">
              <button className="footer__legal-link">Kebijakan Privasi</button>
              <span className="footer__legal-separator">•</span>
              <button className="footer__legal-link">Syarat Layanan</button>
            </p>
          </div>
          
          <button 
            className="footer__scroll-top"
            onClick={scrollToTop}
            aria-label="Kembali ke atas"
          >
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
